import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("mm_token"));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const authAxios = useCallback(
    () => axios.create({ baseURL: API, headers: token ? { Authorization: `Bearer ${token}` } : {} }),
    [token]
  );

  useEffect(() => {
    const check = async () => {
      if (!token) { setUser(false); setLoading(false); return; }
      try {
        const { data } = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
        setUser(data);
      } catch {
        localStorage.removeItem("mm_token");
        setToken(null);
        setUser(false);
      } finally {
        setLoading(false);
      }
    };
    check();
  }, [token]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("mm_token", data.access_token);
    setToken(data.access_token);
    setUser({ email: data.email });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("mm_token");
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ token, user, loading, login, logout, authAxios }}>
      {children}
    </AuthContext.Provider>
  );
};
